import { render, staticRenderFns } from "./GTS500.vue?vue&type=template&id=2f2a95bb&scoped=true&"
import script from "./GTS500.vue?vue&type=script&lang=js&"
export * from "./GTS500.vue?vue&type=script&lang=js&"
import style0 from "./GTS500.vue?vue&type=style&index=0&id=2f2a95bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a95bb",
  null
  
)

export default component.exports